"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Styled = _interopRequireWildcard(require("./SpotIllustration.styles"));
var _SpotIllustration2 = require("./SpotIllustration.utils");
var _SpotIllustration3 = require("./SpotIllustration.types");
var _theming = require("../../theming");
var _constants = require("./constants");
var _ErrorBoundary = require("../../ErrorTracking/ErrorBoundary");
var _excluded = ["alt", "flip", "name", "size", "data-testid", "onError"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var SpotIllustration = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var alt = _ref.alt,
    flip = _ref.flip,
    name = _ref.name,
    size = _ref.size,
    dataTestid = _ref['data-testid'],
    onError = _ref.onError,
    props = _objectWithoutProperties(_ref, _excluded);
  var expectedSrc = (0, _SpotIllustration2.getSpotUrl)(name);
  var fallbackSrc = (0, _SpotIllustration2.getSpotUrl)(name, _theming.Theme.DEFAULT);
  var isSrcAvailable = _constants.AVAILABLE_ILLUSTRATIONS.includes(name);
  if (!name || name && !isSrcAvailable) {
    if (onError) {
      onError({
        currentTarget: {
          src: expectedSrc
        }
      });
    }
    throw new Error("\n".concat(_constants.ERROR_KEY, "\n").concat((0, _SpotIllustration2.getErrorMessage)(name)));
  }
  return /*#__PURE__*/_react["default"].createElement(Styled.Image, _extends({
    ref: ref,
    name: name,
    alt: alt || '',
    src: expectedSrc,
    "data-testid": dataTestid || 'cozy-illustration',
    flip: flip,
    size: size
  }, isSrcAvailable ? (0, _SpotIllustration2.getFallbackIllustration)(fallbackSrc) : {}, props));
});
var sizesPropTypes = _propTypes["default"].oneOf(Object.values(_SpotIllustration3.Size));
var breakpointSizePropTypes = {
  mobile: sizesPropTypes,
  tablet: sizesPropTypes,
  desktop: sizesPropTypes
};
SpotIllustration.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes["default"].oneOf(Object.values(_SpotIllustration3.Name)).isRequired,
  alt: _propTypes["default"].string,
  flip: _propTypes["default"].bool,
  size: _propTypes["default"].oneOfType([sizesPropTypes, _propTypes["default"].shape({
    mobile: sizesPropTypes,
    tablet: sizesPropTypes,
    desktop: sizesPropTypes
  })]),
  onError: _propTypes["default"].func,
  'data-testid': _propTypes["default"].string
} : {};
var _default = exports["default"] = (0, _ErrorBoundary.withErrorBoundary)(SpotIllustration);